"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callWithRetry = void 0;
const axios_1 = __importDefault(require("axios"));
const callWithRetry_1 = __importDefault(require("./callWithRetry"));
exports.callWithRetry = callWithRetry_1.default;
const createRequestSignature = (meta) => `${meta.name}-${meta.method}-${meta.url}`;
let nextRequestId = 0;
const request = (utils) => ({ payload, meta }) => __awaiter(void 0, void 0, void 0, function* () {
    const { name, url, service, requestInfo = {}, map, allowFailure = false, preventConcurrent = false, mock, groupId, disableTimeout = false, } = meta;
    const { activeRequests, serviceCache, next, options } = utils;
    const requestId = `${new Date().getTime()}-${nextRequestId++}`;
    const serviceUrl = yield serviceCache.getUrl(service);
    const signature = createRequestSignature(meta);
    next({
        type: `REQUEST_${name}`,
        payload: Object.assign(Object.assign({}, payload), requestInfo),
        meta,
    });
    try {
        let response;
        const deferedRequest = preventConcurrent ? activeRequests.getBySignature(signature) : undefined;
        if (deferedRequest) {
            response = yield deferedRequest.promise;
        }
        else if (mock) {
            response = typeof mock === 'function' ? mock() : mock;
        }
        else {
            const cancelToken = axios_1.default.CancelToken.source();
            const fqUrl = `${serviceUrl}${url}`;
            const currentRequest = callWithRetry_1.default({
                url: fqUrl,
                utils,
                payload,
                meta,
                cancelToken,
                onUnauthorized: options === null || options === void 0 ? void 0 : options.onUnauthorized,
            });
            let timeoutTimer = 0;
            if (!disableTimeout) {
                timeoutTimer = setTimeout(() => activeRequests.cancel(requestId), 24000);
            }
            activeRequests.addRequest(requestId, {
                signature,
                groupId,
                cancel: () => {
                    cancelToken.cancel();
                },
                preventTimeout: () => {
                    clearTimeout(timeoutTimer);
                },
                promise: currentRequest,
            });
            response = yield currentRequest;
            if (typeof map === 'function') {
                response = yield map(response);
            }
            activeRequests.removeRequest(requestId);
        }
        next({
            type: `RESPONSE_${name}`,
            payload: {
                request: Object.assign(Object.assign({}, payload), requestInfo),
                response,
            },
            meta,
        });
        return response;
    }
    catch (err) {
        activeRequests.removeRequest(requestId);
        next({
            type: `FAILED_${name}`,
            payload: err,
            meta,
        });
        if (!allowFailure) {
            throw err;
        }
        return undefined;
    }
});
exports.default = request;
